import React, { useState, useEffect } from "react"
import SearchLink from "./SearchLink"

export const RecentAndCommonSearches = ({
  commonSearches,
  recentSearchesText,
  commonSearchesText,
  setCurrentRefinement,
}) => {
  const [recentSearches, setRecentSearches] = useState([])

  useEffect(() => {
    if (typeof window !== "undefined") {
      //Format and store recent searches
      const storedSearches = JSON.parse(localStorage.getItem("searches"))
      const localSearches = storedSearches?.map(item => ({
        searchString: item,
      }))
      setRecentSearches(localSearches || [])
    }
  }, [])

  return (
    <>
      <div className="luna-nav-search__recent-and-common-searches luna-nav-search__recent-and-common-searches--recent">
        <p className="luna-nav-search__recent-and-common-searches--header">
          {recentSearchesText}
        </p>
        {recentSearches?.map((recentSearch, i) => (
          <SearchLink
            key={`recent-search-${i}`}
            item={recentSearch}
            setCurrentRefinement={setCurrentRefinement}
          />
        ))}
      </div>
      <div className="luna-nav-search__recent-and-common-searches luna-nav-search__recent-and-common-searches--common">
        <p className="luna-nav-search__recent-and-common-searches--header">
          {commonSearchesText}
        </p>
        {commonSearches?.map((commonSearch, i) => (
          <SearchLink
            key={`common-search-${i}`}
            item={commonSearch}
            setCurrentRefinement={setCurrentRefinement}
          />
        ))}
      </div>
    </>
  )
}

export default RecentAndCommonSearches
